import {
  gql,
  ApolloClient,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client';
import headerCredentials from '../helpers/headerCredentials';

const updateRating = (average_rating, id) => {
  const options = {
    mutation: gql `
      mutation UpdateRatingMutation($average_rating: String, $clientMutationId: String) {
        __typename
        averageRatingMutation(input: {average_rating: $average_rating, clientMutationId: $clientMutationId}) {
          clientMutationId
          exampleOutput
        }
      }
    `,
    variables: {
      average_rating,
      clientMutationId: id
    },
  };

  const link = createHttpLink({
    uri: `${process.env.GATSBY_WP_URL}/graphql`,
    headers: {
      ...headerCredentials(),
    },
    credentials: 'include',
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link,
  });

  return client.mutate(options);
};

export default updateRating;
